import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

/**
 * Initialize testimonials slider
 */
export function initTestimonialsSlider() {
	const testimonialsSliders = document.querySelectorAll('.swiper-testimonials');
	testimonialsSliders.forEach((slider, index) => {
		const swiper = new Swiper(slider, {
			modules: [Navigation, Pagination, A11y],
			grabCursor: true,
			slidesPerView: 1,
			spaceBetween: 30,
			loop: false,
			autoHeight: false,
			keyboard: {
				enabled: true,
			},
			on: {
				init: function () {
					// Force equal heights after initialization
					setTimeout(() => {
						const slides = this.slides;
						let maxHeight = 0;

						// Find the tallest slide
						slides.forEach((slide) => {
							const slideHeight = slide.offsetHeight;
							if (slideHeight > maxHeight) {
								maxHeight = slideHeight;
							}
						});

						// Set all slides to the same height
						slides.forEach((slide) => {
							slide.style.height = maxHeight + 'px';
						});
					}, 100);
				},
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
				type: 'bullets',
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			breakpoints: {
				768: {
					slidesPerView: 2.5,
					spaceBetween: 96,
				},
			},
		});
	});
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', initTestimonialsSlider);
